/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	createMerchantOrderUrl,
	getMerchantPreOrderPaymentOptionsUrl,
	getMerchantPreOrderUrl,
} from '../../endpoints';
import axiosInstance from '../../helpers/axiosInstance';
import MerchantOrder from '../../interfaces/MerchantOrder';
import MerchantPaymentOptions from '../../interfaces/MerchantPaymentOptions';
import MerchantPreOrder from '../../interfaces/MerchantPreOrder';

export const fetchPreorder = createAsyncThunk(
	'PREORDER/FETCH_PREORDER',
	(id: string, { rejectWithValue }) => {
		return axiosInstance
			.get<MerchantPreOrder>(getMerchantPreOrderUrl(id))
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);

export const fetchPaymentOptions = createAsyncThunk(
	'PREORDER/FETCH_PAYMENT_OPTIONS',
	(id: string, { rejectWithValue }) => {
		return axiosInstance
			.get<MerchantPaymentOptions[]>(getMerchantPreOrderPaymentOptionsUrl(id))
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);

export const fetchData = createAsyncThunk('PREORDER/FETCH_DATA', (id: string, { dispatch }) => {
	dispatch(fetchPreorder(id));
	dispatch(fetchPaymentOptions(id));
});

type Customer = {
	type: string;
	privatePerson?: {
		name?: string;
		surname?: string;
		dateOfBirth?: string;
		countryOfResidence?: string;
		email?: string;
	};
	company?: {
		companyName?: string;
		companyCode?: string;
		countryOfRegistration?: string;
		email?: string;
	};
};

type CreateOrderArg = {
	preorderId: string;
	payCurrencyCode: string;
	network: string;
	customer: Customer;
};

export const createOrder = createAsyncThunk(
	'PREORDER/CREATE_ORDER',
	({ preorderId, payCurrencyCode, network, customer }: CreateOrderArg, { rejectWithValue }) => {
		return axiosInstance
			.post<MerchantOrder>(`${createMerchantOrderUrl()}`, {
				preOrderId: preorderId,
				payCurrencyCode,
				payNetworkCode: network,
				customer,
			})
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);
